module.exports = __webpack_public_path__ + "static/media/wcgAntipasto.4126895a.jpg";